var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2h12M1 9l6.613-4.723a.667.667 0 01.774 0L15 9M8 4v11",
    stroke: "#3C3F47",
    strokeWidth: 1.2
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIgMkgxNCIgc3Ryb2tlPSIjM0MzRjQ3IiBzdHJva2Utd2lkdGg9IjEuMiIvPgo8cGF0aCBkPSJNMSA5TDcuNjEyNTEgNC4yNzY3OEM3Ljg0NDMxIDQuMTExMjEgOC4xNTU2OSA0LjExMTIxIDguMzg3NDkgNC4yNzY3OEwxNSA5IiBzdHJva2U9IiMzQzNGNDciIHN0cm9rZS13aWR0aD0iMS4yIi8+CjxwYXRoIGQ9Ik04IDRWMTUiIHN0cm9rZT0iIzNDM0Y0NyIgc3Ryb2tlLXdpZHRoPSIxLjIiLz4KPC9zdmc+Cg==";
export { SvgMailTop as ReactComponent };